import { useEffect, useState } from "react";
import AdminSection from "../AdminSection/AdminSection";
import { get } from "../../services/api";
import { logout } from "../../auth";
import Select from 'react-select';
import CustomMultiSelect from "../CustomMultiSelect/CustomMultiSelect";
import CustomMultiSelectGroup from "../CustomMultiSelectGroup/CustomMultiSelectGroup";
import { useNavigate } from "react-router-dom";

export default function MetasServicoFiltros({ filtros, setMetasValue, resetForm, isSegundaEtapaDesabilitada, setModoInsercao }) {
    
    const navigate = useNavigate();

    const nomeMeses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';

    const selectStyle = { 
        control: (base, state) => ({
            ...base,
            background: "unset",
            borderColor: "#DCDCDC",
            borderRadius: "4px"
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }) 
    }

    const currentDate = new Date()
    function getMonth(monthIndex) {
        const accurateMonthIndex = monthIndex >= 0 ? monthIndex % 12 : 12 + monthIndex % 12
        return {
            label: nomeMeses[accurateMonthIndex],
            value: (accurateMonthIndex) + 1,
            ano: new Date().getFullYear() + Math.floor(monthIndex / 12)
        };
    };

    const optionsMes = [
        getMonth(currentDate.getMonth()),
        getMonth(currentDate.getMonth() + 1)
    ];

    const [ optionsCluster, setOptionsCluster ] = useState([]);
    const [ optionsRegiao, setOptionsRegiao ] = useState([]);
    const [ optionsFilial, setOptionsFilial ] = useState([]);

    async function setOptionsClusterWithRequest(authToken) {
        try {
            const clusters = await get('/admin/metas/cluster', null, authToken)
            setOptionsCluster(clusters.map(cluster => ({ 
                label: cluster.cluster, 
                value: cluster.id_cluster 
            })))

            return clusters
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsRegiaoWithRequest(authToken) {
        try {
            const regioes = await get('/admin/metas/regiao', null, authToken)
            setOptionsRegiao(regioes.map(regiao => ({ 
                label: regiao.nome_regiao, 
                value: regiao.id_regiao 
            })))

            return regioes
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsFilialWithRequest(authToken) {
        try {
            const filiais = await get('admin/metas/filial', null, authToken)
            setOptionsFilial(filiais)

            return filiais
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }

        setOptionsClusterWithRequest(authToken);
        setOptionsRegiaoWithRequest(authToken);
        setOptionsFilialWithRequest(authToken);
    }, []);

    function parseObjectToURLQuery(object) {
        return Object.keys(object).reduce(
            (accumulator, paramKey) => {
                if(object[paramKey]){
                    if(typeof object[paramKey] === 'object'){
                        return accumulator + object[paramKey].reduce((accumulator2, value) => accumulator2 + `&${paramKey}=${value}` , '')
                    }
                    else return accumulator + `&${paramKey}=${object[paramKey]}`
                }
                    
                else return accumulator
            }, '')
    }

    const setMetasServicoPorConsulta = async (cluster, regiao, filial, mes, ano) => {
        if(isSegundaEtapaDesabilitada(cluster, regiao, filial, mes, ano)) {
            return;
        }

        try {
            resetForm();
            setModoInsercao('percentual');

            const authToken = localStorage.getItem("adminToken");

            const requisicao = {
                id_cluster: cluster,
                id_regiao: regiao,
                idfilial: filial,

                mes: mes,
                ano: ano
            }
            const response = await get(`/admin/painelbordo/metas-servico?${parseObjectToURLQuery(requisicao)}`, null, authToken);

            if(response.length > 0 && response.length === response[0].filiais_consultadas.length){
                let isMetasEquals = response.every((meta, index) => (
                    index === 0 ||
                    JSON.stringify(meta.metas) === JSON.stringify(response[index - 1].metas)
                ))
                
                if(isMetasEquals){
                    setMetasValue(response[0].metas.map(meta => ({
                        ... meta,
                        valor: parseFloat(meta.valor).toLocaleString('pt', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
                    })));
                    setModoInsercao(response[0].metas[0].tipo_percentual ? 'percentual' : 'absoluto');
                }
            }

            return response;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    return <>
        <AdminSection
            etapa={1} titulo={'Selecione os filtros'}
        >
            <div className='admin-filtros-dividos p-8'>
                <div className='admin-filtros-left'>
                    <div>
                        <label style={{whiteSpace: 'nowrap'}} htmlFor="mes">Selecione o período</label>
                        <Select
                            name="mes"
                            className="react-select"
                            classNamePrefix="react-select"
                            options={optionsMes}
                            value={filtros.mes.value}
                            onChange={mes => { 
                                filtros.mes.setValue(mes);
                                filtros.ano.setValue(mes.ano);

                                setMetasServicoPorConsulta(
                                    filtros.cluster.value, 
                                    filtros.regiao.value, 
                                    filtros.filial.value,
                                    mes.value, 
                                    mes.ano
                                );
                            }}
                            placeholder="Mês"
                            required
                            menuPortalTarget={document.body} 
                            styles={selectStyle}
                            isSearchable={false}
                            noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        />
                    </div>

                    <div>
                        <input 
                            className="border-gray-c20 rounded text-sm"
                            style={{width: "70px"}}
                            type='text' 
                            name='ano'
                            placeholder='Ano' 
                            value={filtros.ano.value}
                            onChange={(value) => filtros.ano.setValue(value.currentTarget.value)}
                            required
                            readOnly
                        />
                    </div>
                </div>
                <div className='admin-filtros-right' style={{width: "80%"}}>
                    <div>
                        <label style={{whiteSpace: 'nowrap'}} htmlFor="id_cluster">Selecione o cluster</label>
                        <CustomMultiSelect
                            selectedOptions={filtros.cluster.value}
                            setSelectedOptions={filtros.cluster.setValue}
                            filteredOptions={optionsCluster}
                            placeholder={'Cluster'}
                            disabled={
                                (filtros.regiao.value != null && filtros.regiao.value?.length > 0) || 
                                (filtros.filial.value != null && filtros.filial.value?.length > 0)
                            }
                            onChange={(clusters) => {
                                setMetasServicoPorConsulta(
                                    clusters, 
                                    filtros.regiao.value, 
                                    filtros.filial.value,
                                    filtros.mes.value?.value, 
                                    filtros.ano.value
                                );
                            }}
                        />
                    </div>

                    <span className='mb-2'>ou</span>

                    <div>
                        <label style={{whiteSpace: 'nowrap'}} htmlFor="id_regiao">Selecione a região</label>
                        <CustomMultiSelect
                            selectedOptions={filtros.regiao.value}
                            setSelectedOptions={filtros.regiao.setValue}
                            filteredOptions={optionsRegiao}
                            placeholder='Região'
                            disabled={
                                (filtros.cluster.value != null && filtros.cluster.value?.length > 0) || 
                                (filtros.filial.value != null && filtros.filial.value?.length > 0) 
                            }
                            onChange={(regioes) => {
                                setMetasServicoPorConsulta(
                                    filtros.cluster.value, 
                                    regioes, 
                                    filtros.filial.value,
                                    filtros.mes.value?.value, 
                                    filtros.ano.value
                                );
                            }}
                        />
                    </div>

                    <span className='mb-2'>ou</span>

                    <div className="multi-select-group-wrapper">
                        <label htmlFor="idfiliais">Selecione as filiais</label>
                        <CustomMultiSelectGroup
                            options={optionsFilial}
                            selectedOptions={filtros.filial.value}
                            setSelectedOptions={filtros.filial.setValue}
                            placeholder="Filiais"
                            className='input-idfiliais'
                            disabled={
                                (filtros.cluster.value != null && filtros.cluster.value?.length > 0) || 
                                (filtros.regiao.value != null && filtros.regiao.value?.length > 0)
                            }
                            doOnChange={(filiais) => {
                                setMetasServicoPorConsulta(
                                    filtros.cluster.value, 
                                    filtros.regiao.value, 
                                    filiais,
                                    filtros.mes.value?.value, 
                                    filtros.ano.value
                                );
                            }}
                        />
                    </div>
                </div>
            </div>
        </AdminSection>
    </>
}